export enum Interior {
  Bad = 'Sämre Skick',
  Good = 'Bra skick',
  Excellent = 'Utmärkt skick',
  New = 'Nybilsskick',
}

export enum Exterior {
  Bad = 'tydligt slitage',
  Good = 'mindre synligt slitage',
  Excellent = 'lättare synligt slitage',
  New = 'inget synligt slitage',
}

export enum WinterTires {
  Bad = 'Vinterdäck följer inte',
  Good = 'Dags att byta',
  Excellent = 'Använda',
  New = 'Nya',
}

export enum SummerTires {
  Bad = 'Sommardäck följer inte',
  Good = 'Dags att byta',
  Excellent = 'Använda',
  New = 'Nya',
}
